import { render, staticRenderFns } from "./AxLogin.vue?vue&type=template&id=4a2f21c7&scoped=true"
import script from "./AxLogin.vue?vue&type=script&lang=ts"
export * from "./AxLogin.vue?vue&type=script&lang=ts"
import style0 from "./AxLogin.vue?vue&type=style&index=0&id=4a2f21c7&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a2f21c7",
  null
  
)

export default component.exports